import React, {useEffect, useState} from "react";
import SpriteLogo from './svgs/sprite.svg';
import ApiService from "../../network/ApiService";
import {useSelector} from "react-redux";
import {Link, NavLink} from "react-router-dom";
import NepaliFlag from './svgs/np.svg';
import EnglishFlag from './svgs/us.svg';
function TopBar(props) {
    console.log("This is props",props);
    document.addEventListener('keydown', e => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        const focusElem = document.querySelector(':focus');
        const tabElements = [...document.querySelectorAll('#searchInput, #searchList>li.display>a')];
        const tabElementsCount = tabElements.length - 1;
        if (!tabElements.includes(focusElem)) return;
        e.preventDefault();
        const focusIndex = tabElements.indexOf(focusElem);
        let elemToFocus;
        if (e.key === 'ArrowUp') elemToFocus = tabElements[focusIndex > 0 ? focusIndex - 1 : tabElementsCount];
        if (e.key === 'ArrowDown') elemToFocus = tabElements[focusIndex < tabElementsCount ? focusIndex + 1 : 0];
        elemToFocus.focus();
    });
    const contactsList = props.contactList;
    const orgDetail = props.orgDetail;
    const [phone, setPhone] = useState(null);
    const [email, setEmail] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [messages, setMessages] = useState([]);
    const [searchList, setSearchList] = useState([]);
    const [showSearchList, setShowSearchList] = useState(false);
    const [language, setLanguage] = useState('en');
    const languageStatus = sessionStorage.getItem("language");
    const {
        fetchMessages,
    } = ApiService();

    const {organizationId} = useSelector((state) => state.organization);
// console.log("I am checking Organization id from TopBar.js",orgDetail);
    const fetchStaffMessages = async () => {
      try {
        const response = await fetchMessages();
        setMessages(response.data.mapOfIdAndDisplayLabels);
      } catch (error) {
        console.log(error.message);
      }
    };

      const changeLanguage = (language : 'en') => {
            const languageStatus = sessionStorage.getItem("language");
            if (languageStatus !== ''){
                setLanguage(language);
                sessionStorage.setItem("language", language);
            }
        }


    const toggleSearch = (e) => {
        setShowSearchList(!showSearchList)
    }

    const handleInputChange = (e) => {
        let searchList = [];
        if (e.target.value === '') {
            setSearchList([]);
            return;
        }
        const list = {
            'home': {
                'name': 'Home (गृहपृष्ठ)',
                'url': '/'
            },
            'about': {
                'name': 'About Us (संस्थाको जानकारी)',
                'url': 'about'
            },
            'news': {
                'name': 'News (समाचार)',
                'url': 'news'
            },
            'notices': {
                'name': 'Notices (सुचना/गतिविधि)',
                'url': 'notices'
            },
            'services': {
                'name': 'Our Services (हाम्रा सेवाहरू)',
                'url': 'our-services'
            },
            'outstanding-report': {
                'name': 'Outstanding Details (बक्यौता विवरण)',
                'url': 'outstanding-report'
            },
            'complain-service': {
                'name': 'Complain Register (गुनासो सेवा)',
                'url': 'complain-service'
            },
            'water-schedule': {
                'name': 'Water Distribution Schedule (पानी बितरण तालिका)',
                'url': 'water-schedule'
            },
            'meter-reading-schedule': {
                'name': 'Meter Reading Schedule (रिडिङ्ग तालिका)',
                'url': 'meter-reading-schedule'
            },
            'download': {
                'name': 'Download (डाउनलोड)',
                'url': 'download'
            },
            'gallery': {
                'name': 'Photo Gallery (फोटो ग्यालरी)',
                'url': 'gallery'
            },
            'team': {
                'name': 'Members (सदस्य)',
                'url': 'team'
            },
            'contact': {
                'name': 'Contact (सम्पर्क)',
                'url': 'contact'
            },
        };

        for (let listKey in list) {
            if ((list[listKey].name).toLowerCase().includes((e.target.value).toLowerCase())) {
                searchList.push(list[listKey]);
            }
        }
        setSearchList(searchList);
        setShowSearchList(true)
    };

    useEffect(() => {
        if (organizationId) {
            fetchStaffMessages();
        }
        if (Object.keys(contactsList).length > 0) {
            setPhone(contactsList.find((item) => item.contactType === "Phone"));
            setEmail(contactsList.find((item) => item.contactType === "Email"));
        }
    }, [contactsList]);

    return (<>
<div
  className="topbar uk-visible@l"
style={{backgroundColor:'#0f2495'}}
>

  <nav className="uk-navbar uk-flex uk-flex-middle uk-flex-between" style={{ padding: '0 16px' ,height:'73px'}}>
    
    {/* Left: Logo */}
    <div className="uk-navbr" style={{}}>
      <Link to="/" aria-label="Back to home" className="uk-logo uk-navbar-item" > 
        {orgDetail.bannerImage ? (
          <picture>
            <source type="image/webp" sizes="(min-width: 55px) 55px" />
            <img
              alt=""
              loading="eager"
              src={orgDetail.bannerImage || `assets/images/image.jpg`}
              style={{ height: '70px'}}
            />
          </picture>
        ) : null}
      </Link>
    </div>

    {/* Middle: Search bar container */}
    <div 
      className="uk-navbar-center uk-visible@m" 
style={{ flex: '1 1 auto', maxWidth: '390px', marginLeft: '400px' ,height:'30px',color:"white"}}
    >
      <form
        onSubmit={(e) => e.preventDefault()}
        id="ns-search"
        action=""
        method="get"
        role="search"
        className="uk-search uk-search-default uk-width-1-1"
        target="_self"
      >
        <button uk-search-icon="" className="uk-search-icon-flip uk-icon uk-search-icon" type="submit">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <circle fill="none" stroke="#000" strokeWidth="1.1" cx="9" cy="9" r="7" />
            <path fill="none" stroke="#000" strokeWidth="1.1" d="M14,14 L18,18 L14,14 Z" />
          </svg>
        </button>
<input
  id="searchInput"
  name="s"
  type="search" // also fix type to "search" for proper HTML semantics
  placeholder={languageStatus === 'en' ? 'Search' : `खोज`}
  className="uk-search-input uk-light"
  autoComplete="off"
  onClick={(e) => handleInputChange(e)}
  onChange={(e) => handleInputChange(e)}
  style={{
    paddingLeft: '40px',
    border: '1px solid white', // <-- this makes all sides white
    color: 'white',
    backgroundColor: 'transparent'
  }}
/>
      </form>

      <div className="uk-position-absolute search_bar" style={{ top: '100%', left: 0, right: 0, zIndex: 1000 }}>
        {showSearchList && searchList.length > 0 ? (
          <ul className="uk-list" id="searchList" style={{ backgroundColor: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            {searchList.map((data, index) => (
              <li
                key={index}
                className="el-item uk-link-reset display"
                onClick={(e) => toggleSearch()}
                style={{ padding: '8px 12px', cursor: 'pointer' }}
              >
                <Link to={data.url} style={{ color: '#333', textDecoration: 'none' }}>{data.name}</Link>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>

    {/* Right: empty or future use (if needed) */}
    <div className="uk-navbar-right" style={{ flex: '0 0 auto', minWidth: '100px' }}>
    
      {/* You can put icons or buttons here if needed later */}
    </div>

     <div
  className="uk-width-auto uk-position-absolute"
  style={{
    height: '38px',
    right: '16px', // position from right side for a fixed placement
    top: '16px',   // adjust top as needed to align vertically
    display: 'flex',
    gap: '10px', // space between buttons
    alignItems: 'center',
    marginRight:'100px'
  }}
>
  <Link
    onClick={() => changeLanguage('en')}
    className="uk-link uk-link-reset"
    style={{ textDecoration: 'none' }}
  >
    <button
      className="uk-button-link uk-border-rounded uk-box-shadow-small"
      style={{
        cursor: 'pointer',
        border: languageStatus === 'en' ? '2px solid white' : '2px solid transparent',
        padding: '6px 18px',
        fontWeight: '600',
        fontSize: '16px',
        color: 'white',
        backgroundColor: 'transparent',
        borderRadius: '8px',
        transition: 'background-color 0.3s, color 0.3s',
        height: '38px',
        minWidth: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = 'white';
        e.currentTarget.style.color = '#0f2495';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = 'white';
      }}
    >
      EN
    </button>
  </Link>

  <Link
    onClick={() => changeLanguage('np')}
    className="uk-link uk-link-reset"
    style={{ textDecoration: 'none' }}
  >
    <button
      className="uk-button-link uk-border-rounded uk-box-shadow-small"
      style={{
        cursor: 'pointer',
        border: languageStatus === 'np' ? '2px solid white' : '2px solid transparent',
        padding: '6px 18px',
        fontWeight: '600',
        fontSize: '16px',
        color: 'white',
        backgroundColor: 'transparent',
        borderRadius: '8px',
        transition: 'background-color 0.3s, color 0.3s',
        height: '38px',
        minWidth: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = 'white';
        e.currentTarget.style.color = '#0f2495';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = 'white';
      }}
    >
      NP
    </button>
  </Link>
</div>

  </nav>


</div>

 </>
    );
}

export default TopBar;
